import React, { type FunctionComponent } from 'react'
import { FormattedMessage, FormattedNumber } from 'react-intl'
import { Text } from 'ic-snacks'

export type RefundCellProps = {
  refund: string | number
}

export const RefundCell: FunctionComponent<RefundCellProps> = ({ refund }) => {
  let content = <FormattedMessage id="orders.details.refund.no" />

  if (typeof refund === 'string') {
    content = <FormattedMessage id="orders.details.refund.yes" />
  }

  if (typeof refund === 'number') {
    content = <FormattedNumber value={refund} style="currency" currency="USD" />
  }

  return <Text variant="T.16">{content}</Text>
}
